import { useEffect } from "react";
import { attachAmountFormatter } from "./amountFormat";

export default function ExcludeBehaviour() {
  useEffect(() => {
    const toggle = document.getElementById("themeSwitch");

    if (toggle) {
      if (localStorage.getItem("theme") === "dark") {
        document.body.classList.add("dark-theme");
        toggle.checked = true;
      }

      toggle.addEventListener("change", () => {
        if (toggle.checked) {
          document.body.classList.add("dark-theme");
          localStorage.setItem("theme", "dark");
        } else {
          document.body.classList.remove("dark-theme");
          localStorage.setItem("theme", "light");
        }
      });
    }

    ["purchasePriceInput", "loanInput", "currentPriceInput"].forEach((id) => {
      attachAmountFormatter(document.getElementById(id));
    });

    if (window.App && window.App.refreshInputAdornments) {
      window.App.refreshInputAdornments(document.querySelector(".right") || document);
    }
  }, []);

  return null;
}
